var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Layout",
    [
      _c("PageHeader", { attrs: { title: _vm.title, items: _vm.items } }),
      _vm.podeVerIndicadores
        ? _c("div", { staticClass: "card mb-3" }, [
            _c("div", { staticClass: "card-body" }, [
              _c(
                "div",
                { staticClass: "row g-2 align-items-end" },
                [
                  _c(
                    "div",
                    { staticClass: "col-sm-6 col-md-3 col-lg-2" },
                    [
                      _c("label", { staticClass: "form-label mb-1" }, [
                        _vm._v("Período inicial"),
                      ]),
                      _c("FDateInput", {
                        key: "dt_start_" + _vm.filter.periodoStart,
                        on: { change: _vm.onPeriodoChange },
                        model: {
                          value: _vm.filter.periodoStart,
                          callback: function ($$v) {
                            _vm.$set(_vm.filter, "periodoStart", $$v)
                          },
                          expression: "filter.periodoStart",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-sm-6 col-md-3 col-lg-2" },
                    [
                      _c("label", { staticClass: "form-label mb-1" }, [
                        _vm._v("Período final"),
                      ]),
                      _c("FDateInput", {
                        key: "dt_end_" + _vm.filter.periodoEnd,
                        on: { change: _vm.onPeriodoChange },
                        model: {
                          value: _vm.filter.periodoEnd,
                          callback: function ($$v) {
                            _vm.$set(_vm.filter, "periodoEnd", $$v)
                          },
                          expression: "filter.periodoEnd",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("f-selectsearch", {
                    ref: "hospitalId",
                    attrs: {
                      label: "Hospital",
                      name: "hospitalId",
                      cols: 3,
                      searchFunction: _vm.consultarHospital,
                      placeholder: "Todos",
                    },
                    on: { select: _vm.onHospitalSelect },
                    model: {
                      value: _vm.filter.hospitalId,
                      callback: function ($$v) {
                        _vm.$set(_vm.filter, "hospitalId", $$v)
                      },
                      expression: "filter.hospitalId",
                    },
                  }),
                  _c("f-selectsearch", {
                    ref: "convenioId",
                    attrs: {
                      label: "Convênio",
                      name: "convenioId",
                      cols: 3,
                      searchFunction: _vm.consultarConvenio,
                      placeholder: "Todos",
                    },
                    on: { select: _vm.onConvenioSelect },
                    model: {
                      value: _vm.filter.convenioId,
                      callback: function ($$v) {
                        _vm.$set(_vm.filter, "convenioId", $$v)
                      },
                      expression: "filter.convenioId",
                    },
                  }),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
      _vm.erro
        ? _c("b-alert", { attrs: { show: "", variant: "danger" } }, [
            _vm._v(_vm._s(_vm.erro)),
          ])
        : _vm._e(),
      _vm.podeVerIndicadores
        ? _c("div", [
            _vm.semDados
              ? _c(
                  "div",
                  {
                    staticClass:
                      "alert alert-light border text-center py-4 mb-3",
                  },
                  [
                    _vm._v(
                      " Nenhum lote encontrado para o período e filtros selecionados. "
                    ),
                  ]
                )
              : _vm._e(),
            _c("div", { staticClass: "row g-3 mb-4" }, [
              !_vm.ocultaNaoIniciado
                ? _c(
                    "div",
                    { staticClass: "col-sm-6 col-xl-3" },
                    [
                      _c("KpiCard", {
                        attrs: {
                          label: "Não iniciados",
                          value: _vm.resumo.naoIniciados,
                          "value-label": "lotes",
                          "secondary-value": _vm.resumo.guiasNaoIniciadas,
                          icon: "mdi mdi-clock-outline",
                          color: "danger",
                          to: _vm.linkLotes({ status: "NAO_INICIADO" }),
                          loading: _vm.loading,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "col-sm-6 col-xl-3" },
                [
                  _c("KpiCard", {
                    attrs: {
                      label: "Em auditoria",
                      value: _vm.resumo.emAuditoria,
                      "value-label": "lotes",
                      "secondary-value": _vm.resumo.guiasEmAuditoria,
                      icon: "mdi mdi-clipboard-edit-outline",
                      color: "warning",
                      to: _vm.linkLotes({ status: "EM_AUDITORIA" }),
                      loading: _vm.loading,
                    },
                  }),
                ],
                1
              ),
              _vm.mostraKpiConsenso
                ? _c(
                    "div",
                    { staticClass: "col-sm-6 col-xl-3" },
                    [
                      _c("KpiCard", {
                        attrs: {
                          label: "Aguardando consenso",
                          value: _vm.resumo.aguardandoConsenso,
                          "value-label": "lotes",
                          "secondary-value": _vm.resumo.guiasAguardandoConsenso,
                          icon: "mdi mdi-handshake-outline",
                          color: "info",
                          to: _vm.linkLotes({
                            status: "AGUARDANDO_CONSENSO",
                            aguardandoConsenso: true,
                          }),
                          loading: _vm.loading,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isHospitalConsenso &&
              (_vm.isGoCareConsenso || _vm.podeVerIndicadores)
                ? _c(
                    "div",
                    { staticClass: "col-sm-6 col-xl-3" },
                    [
                      _c("KpiCard", {
                        attrs: {
                          label: "Retorno de contestação",
                          value: _vm.resumo.retornoContestacao,
                          "value-label": "lotes",
                          "secondary-value": _vm.resumo.guiasRetornoContestacao,
                          icon: "mdi mdi-backup-restore",
                          color: "warning",
                          to: _vm.linkLotes({
                            status: "EM_AUDITORIA",
                            retornoContestacao: true,
                          }),
                          loading: _vm.loading,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "col-sm-6 col-xl-3" },
                [
                  _c("KpiCard", {
                    attrs: {
                      label: "Auditados",
                      value: _vm.resumo.auditados,
                      "value-label": "lotes",
                      "secondary-value": _vm.resumo.guiasAuditadas,
                      icon: "mdi mdi-check-circle-outline",
                      color: "success",
                      to: _vm.linkLotes({ status: "AUDITADO" }),
                      loading: _vm.loading,
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-sm-6 col-xl-3" },
                [
                  _c("KpiCard", {
                    attrs: {
                      label: "Total de lotes",
                      value: _vm.resumo.totalLotes,
                      icon: "mdi mdi-package-variant-closed",
                      color: "primary",
                      to: _vm.linkLotes(),
                      loading: _vm.loading,
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-sm-6 col-xl-3" },
                [
                  _c("KpiCard", {
                    attrs: {
                      label: "Total de guias",
                      value: _vm.resumo.totalGuias,
                      icon: "mdi mdi-file-document-multiple-outline",
                      color: "info",
                      loading: _vm.loading,
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-sm-6 col-xl-3" },
                [
                  _c("KpiCard", {
                    attrs: {
                      label: "Valor faturado",
                      value: _vm.resumo.valorFaturado,
                      format: "currency",
                      icon: "mdi mdi-currency-usd",
                      color: "primary",
                      loading: _vm.loading,
                    },
                  }),
                ],
                1
              ),
              !_vm.isHospitalConsenso
                ? _c(
                    "div",
                    { staticClass: "col-sm-6 col-xl-3" },
                    [
                      _c("KpiCard", {
                        attrs: {
                          label: "Sugestões IA pendentes",
                          value: _vm.resumo.lotesComIaPendente,
                          icon: "mdi mdi-robot-outline",
                          color: "secondary",
                          to: _vm.linkLotes({ filtroIa: "PENDENTES" }),
                          loading: _vm.loading,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ])
        : _vm.podeVerUpload
        ? _c("div", { staticClass: "card mb-4" }, [
            _c(
              "div",
              { staticClass: "card-body text-center py-5" },
              [
                _c("i", {
                  staticClass:
                    "mdi mdi-home-variant-outline text-primary font-size-48 d-block mb-3",
                }),
                _c("h5", { staticClass: "mb-2" }, [
                  _vm._v("Bem-vindo ao Go Care"),
                ]),
                _c("p", { staticClass: "text-muted mb-4" }, [
                  _vm._v(
                    "Envie novos lotes de faturamento para iniciar o fluxo de auditoria."
                  ),
                ]),
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { to: "/faturamento/lote/upload" },
                  },
                  [
                    _c("i", { staticClass: "mdi mdi-upload me-1" }),
                    _vm._v(" Ir para upload "),
                  ]
                ),
              ],
              1
            ),
          ])
        : _c("div", { staticClass: "card mb-4" }, [
            _c("div", { staticClass: "card-body text-center py-5" }, [
              _c("i", {
                staticClass:
                  "mdi mdi-home-variant-outline text-primary font-size-48 d-block mb-3",
              }),
              _c("h5", { staticClass: "mb-2" }, [
                _vm._v("Bem-vindo ao Go Care"),
              ]),
              _c("p", { staticClass: "text-muted mb-0" }, [
                _vm._v(
                  "Utilize o menu lateral para acessar as funcionalidades disponíveis no seu perfil."
                ),
              ]),
            ]),
          ]),
      _vm.atalhos.length
        ? _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-body" }, [
              _c("h5", { staticClass: "card-title mb-3" }, [_vm._v("Atalhos")]),
              _c(
                "div",
                { staticClass: "row g-2" },
                _vm._l(_vm.atalhos, function (atalho) {
                  return _c(
                    "div",
                    {
                      key: atalho.to,
                      staticClass: "col-sm-6 col-md-4 col-lg-3",
                    },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass:
                            "btn btn-outline-primary w-100 text-start",
                          attrs: { to: atalho.to },
                        },
                        [
                          _c("i", { class: [atalho.icon, "me-2"] }),
                          _vm._v(_vm._s(atalho.label) + " "),
                        ]
                      ),
                    ],
                    1
                  )
                }),
                0
              ),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }